import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MScreen from "../../components/pos/MScreen";
import db from "../../db/db";

import { Typography } from "@mui/material";
import DayCloseSummary from "../sale/saleFlow/DayCloseSummary";

export default function RegisterDevice(props) {
  const { t, i18n } = useTranslation();
  const translate = t;

  useEffect(() => {
    deviceLookup();
  }, []);

  async function deviceLookup() {
    let loop = true;
    while (loop) {
      console.log("Terminal Lookup");
      let dbData = await db.terminal.toArray();
      for (let d of dbData) {
        if (d.deviceId === props.deviceId) {
          props.setTerminalBean(d);
          props.checkSaleFlow(d);
          loop = false;
        }
      }
      await sleep(1000);
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function onOkayClicked() {}

  function dummy() {}

  return (
    <MScreen
      title={translate("Register Device")}
      isMoreMenuEnabled={false}
      rightAction={translate("OK")}
      enbaleRightAction={false}
      onRightAction={onOkayClicked}
      onLogOut={props.onLogOut}
      onRedirectToBack={() =>
        props.context.appMode === "desktop-pos"
          ? props.setCurrentPage("dashboard")
          : dummy
      }
      content={
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom component="div">
              {props.deviceId}
            </Typography>
            {translate(
              "Device with above ID is not registered, Please register using terminal settings screen"
            )}
          </Grid>
        </Grid>
      }
    ></MScreen>
  );
}
